import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;

    width: 100%;
    padding: 35px 24px;
    background: ${`${theme?.colour?.primary ?? '#1DBD6B'}0D`};
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  `}
`;


export default Wrapper(template);